import React, { useEffect, useState } from 'react'
import { imamLiAktivanKomentar, potvrdiPrekiniPredrezervaciju } from '../../api/predrezervacijaMaterijala'
import 'react-toastify/dist/ReactToastify.css'
import notifyToast from '../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'

const PredrezervacijaKomentari: React.FC = () => {
    const [komentar, setKomentar] = useState('')
    const [dani, setDani] = useState('')
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [loading, setLoading] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [uposlenikId, setUposlenikId] = useState<number | null>(null)
    const [predrezervacijaId, setPredrezervacijaId] = useState<number | null>(null)
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        const stored = localStorage.getItem('kt-auth-react-v')
        if (stored) {
            try {
                const parsed = JSON.parse(stored)
                if (parsed?.UposlenikId) {
                    setUposlenikId(parsed.UposlenikId)
                } else {
                    setError('UposlenikId nije pronađen.')
                }
            } catch (e) {
                console.error('Greška prilikom parsiranja localStorage:', e)
                setError('Nevažeći korisnički podaci.')
            }
        } else {
            setError('Korisnik nije prijavljen.')
        }
    }, [])

    useEffect(() => {
        if (uposlenikId) {
            imamLiAktivanKomentar(uposlenikId)
                .then((res) => {
                    if (res.length > 0) {
                        setShowForm(true)
                        setPredrezervacijaId(res[0].Id)
                        setData(res)
                    }
                })
                .catch((err) => setError(err.message))
        }
    }, [uposlenikId])

    const handleSubmit = async (akcija: 'potvrdi' | 'prekini') => {
        setError('')
        setSuccess('')
        setLoading(true)

        if (!komentar.trim()) {
            setError('Komentar je obavezan.')
            setLoading(false)
            return
        }

        let produziDana = 0
        if (akcija === 'potvrdi') {
            const daniInt = parseInt(dani)
            if (!dani || isNaN(daniInt) || daniInt < 11 || daniInt > 31) {
                setError('Unesite broj dana između 11 i 30.')
                setLoading(false)
                return
            }
            produziDana = daniInt
        }

        if (!uposlenikId || !predrezervacijaId) {
            setError('Nedostaju podaci za slanje.')
            setLoading(false)
            return
        }
        console.log(predrezervacijaId, 'predrezervacijaId')
        try {
            const responseData = await potvrdiPrekiniPredrezervaciju({
                Akcija: akcija,
                Id: predrezervacijaId,
                IdUposlenika: uposlenikId,
                Komentar: komentar,
                ProduziDana: produziDana,
            })

            if (responseData.error === 0) {
                notifyToast(true, responseData.data || responseData.message || 'Uspješno.')
                setShowForm(false)
            } else {
                notifyToast(false, responseData.message || 'Došlo je do greške.')
            }

        } catch (err: any) {
            notifyToast(false, err.message || 'Greška pri slanju zahtjeva.')
        } finally {
            setLoading(false)
        }
    }


    if (!showForm) return null

    return (
        <div className='col-xl-12 alert alert-danger'>
            <div className='row mb-6'>
                <div className='col-xl-4 col-sm-12'>
                    <h3 className='mt-2'>
                        Vaša rezervacija broj: {data[0].predrezervacija.Id} ističe za tri dana.
                    </h3>
                </div>
                <div className='col-xl-8 col-sm-12'>
                    <h3 className='mt-2'>Projekat: {data[0].predrezervacija.NazivProjekta} | Kupac: {data[0].predrezervacija.Kupac}</h3>
                </div>
            </div>
            Upišite komentar i broj dana (min 11.dana & max 30) ako želite PRODUŽITI rezervaciju.
            <h4 className='mt-5'>Upišite komentar</h4>
            <div className='mb-3'>
                <textarea
                    className='form-control'
                    rows={3}
                    placeholder='Unesite komentar...'
                    value={komentar}
                    onChange={(e) => setKomentar(e.target.value)}
                />
            </div>

            <div className='mb-3'>
                <label className='form-label'>Produžetak dana (11–30)</label>
                <input
                    type='number'
                    className='form-control'
                    value={dani}
                    onChange={(e) => setDani(e.target.value)}
                    min={11}
                    max={30}
                    disabled={loading}
                />
            </div>

            {error && <div className='text-danger mb-3'>{error}</div>}
            {success && <div className='text-success mb-3'>{success}</div>}

            <div className='d-flex gap-2'>
                <button className='btn btn-success' onClick={() => handleSubmit('potvrdi')} disabled={loading}>
                    {loading ? 'Obrada...' : 'Produži rezervaciju'}
                </button>
                <button className='btn btn-danger' onClick={() => handleSubmit('prekini')} disabled={loading}>
                    {loading ? 'Obrada...' : 'Prekini rezervaciju'}
                </button>
            </div>
        </div>
    )
}

export default PredrezervacijaKomentari
